<template lang="pug">
    fragment
        // Arrow
        td
            icon-component(:expanded="expanded")

        // Program Name
        td
            div.name {{ item.title }}

        // Actions
        td.px-0.text-xs-right

            // Edit program button
            button-component(:action="edit" color="primary" icon="edit")

            // Delete program button
            button-component(:action="deleteProgram" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import ExpandIcon from '~components/ExpandIcon';
    import Status from '~components/Status';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon,
            StatusComponent: Status,
            IconComponent: ExpandIcon
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        methods: {
            ...mapActions('programs', ['deleteProgram']),

            /**
             * Edit Program
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.programs.edit',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete Program
             * @returns {Promise<void>}
             */
            async deleteProgram() {
                const resp = await this.deleteProgram(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .name
        max-width: 160px
        overflow: hidden
        text-overflow: ellipsis
</style>
